import { useSuspenseQuery } from '@tanstack/react-query';
import orderBy from 'lodash.orderby';

import { apiClient } from '@/_shared/utils';

import type { TCountriesModel } from '../../../../_schemas/countries/model';

export const USA_COUNTRY = 'united states of america';

export function useGetCountries(props?: { apiParamStr?: string; sort?: 'asc' | 'desc' | 'reverse' }) {
  const { apiParamStr = '?per_page=1000&filter[status]=active', sort = 'asc' } = props ?? {};
  return useSuspenseQuery({
    queryKey: ['COUNTRIES', apiParamStr, sort],
    staleTime: 30 * 24 * 60 * 60 * 1000, // 30 days — countries list rarely changes
    queryFn: async () => {
      const res = await apiClient.get<TCountriesModel>({
        endpoint: '/api/v1/countries',
        params: `${apiParamStr}&include=flag`,
      });

      if (sort === 'asc' || sort === 'desc') {
        let arr = res?.data || [];
        if (sort === 'asc') {
          arr = orderBy(arr, ['name'], ['asc']);
        } else if (sort === 'desc') {
          arr = orderBy(arr, ['name'], ['desc']);
        }

        const found = arr.find((item) => item.name.toLowerCase() === USA_COUNTRY);

        if (found) {
          const filtered = arr.filter((item) => item.name.toLowerCase() !== USA_COUNTRY);
          arr = [found, ...filtered];
        }

        return { ...res, data: arr };
      }

      return res;
    },
  });
}
